import React, { useEffect, useState } from "react";
import Loader from "../../..//Utils/Loader";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Content from "../../../Components/Dashboard/Content/Content";
import Formikform from "../../../Components/ExtraComponents/Form/Formik_form1";
import * as valid_err from "../../../Utils/Common_Messages";
import { Get_Panel_Informtion } from "../../../ReduxStore/Slice/Auth/AuthSlice";

import { useFormik } from "formik";
import { Update_Panel } from "../../..//ReduxStore/Slice/Superadmin/SuperAdminSlice";
import { useDispatch, useSelector } from "react-redux";
import { Get_All_Theme_Name } from "../../../ReduxStore/Slice/ThemeSlice";
import { All_Brokers } from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";

import toast, { Toaster } from "react-hot-toast";

import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";

const Edit_panel = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const user_token = JSON.parse(localStorage.getItem("user_details")).token;
  const Role = JSON.parse(localStorage.getItem("user_details")).Role;
  const user_id = JSON.parse(localStorage.getItem("user_details")).user_id;
  const UserName = JSON.parse(localStorage.getItem("user_details")).UserName;

  const [getAllThemeName, setAllThemeName] = useState([]);
  const [getGetAllBrokerName, setGetAllBrokerName] = useState([]);

  const [Addsubadmin, setAddsubadmin] = useState({
    loading: false,
    data: [],
  });

  const [UserData, setUserData] = useState({
    loading: false,
    data: [],
  });

  const [state1, setstate1] = useState([]);
  const [getBrokerNames, setBrokerNames] = useState([]);

  const formik = useFormik({
    initialValues: {
      panel_name: "",
      domain: "",
      port: "",
      key: "",
      ip_address: "",
      is_active: 0,
      is_expired: 0,
      theme_id: "",
      db_url: "",
      backend_rul: "",
      // db_name: "",
      broker_id: [],
      Create_Strategy: false,
      Option_chain: false,
      Strategy_plan: false,
      LoginPage: 0,
      AddClient: 0,
      InvoicePermission: 0,
      sevant_day: 0,
      tradeHistoryDeltaExchange: 0,
    },

    validate: (values) => {
      const errors = {};

      if (!values.panel_name && formik.touched.panel_name) {
        errors.panel_name = valid_err.PANEL_NAME_ERROR;
      }

      if (!values.domain && formik.touched.domain) {
        errors.domain = valid_err.DOMAIN_ERROR;
      }

      if (!values.port && formik.touched.port) {
        errors.port = valid_err.PORT_ERROR;
      }

      if (!values.key && formik.touched.key) {
        errors.key = valid_err.KEY_ERROR;
      }

      if (!values.db_url && formik.touched.db_url) {
        errors.db_url = valid_err.DBURL_ERROR;
      }

      // if (!values.db_name && formik.touched.db_name) {
      //     errors.db_name = valid_err.DBNAME_ERROR;
      // }

      if (!values.backend_rul) {
        errors.backend_rul = valid_err.BACKNEDURL_ERROR;
      }
      // if (!values.tradeHistoryDeltaExchange && formik.touched.tradeHistoryDeltaExchange) {
      //   errors.tradeHistoryDeltaExchange = valid_err.TRADE_HISTORY_DELTA_EXCHANGE_ERROR;
      // }

      return errors;
    },
    onSubmit: async (values) => {
      const req = {
        _id: location.state._id,
        panel_name: values.panel_name,
        domain: values.domain,
        port: values.port,
        key: values.key,
        ip_address: values.ip_address,

        db_url: values.db_url,
        // db_name: values.db_name,
        broker_id: getBrokerNames,
        Create_Strategy:
          values.Create_Strategy && values.Create_Strategy ? 1 : 0,

        backend_rul: values.backend_rul,
        UserName: UserName,
        LoginPage: values.LoginPage,
        AddClient: values.AddClient,
        InvoicePermission: values.InvoicePermission,
        sevant_day: values.sevant_day,
        tradeHistoryDeltaExchange: values.tradeHistoryDeltaExchange,
      };

      await dispatch(Update_Panel(req))
        .unwrap()
        .then((response) => {
          if (response.status === 409) {
            toast.error(response.data.msg);
          } else if (response.status) {
            toast.success(response.msg);

            setTimeout(() => {
              navigate("/super/alladmins");
            }, 1000);
          } else if (!response.status) {
            toast.error(response.msg);
          }
        });
    },
  });

  const getPanelDetails = async () => {
    const req = {
      domain: location.state.domain,
    };

    await dispatch(Get_Panel_Informtion(req))
      .unwrap()
      .then((response) => {
        setUserData({
          loading: false,
          data: response.data,
        });
      });
  };

  useEffect(() => {
    getPanelDetails();
  }, []);

  useEffect(() => {
    if (UserData.data && UserData.data.length > 0 && UserData.data[0]) {
      const userPanelData = UserData.data[0];

      formik.setFieldValue(
        "panel_name",
        (userPanelData && userPanelData.panel_name) || ""
      );
      formik.setFieldValue(
        "domain",
        (userPanelData && userPanelData.domain) || ""
      );
      formik.setFieldValue("port", (userPanelData && userPanelData.port) || "");
      formik.setFieldValue("key", (userPanelData && userPanelData.key) || "");
      formik.setFieldValue(
        "ip_address",
        (userPanelData && userPanelData.ip_address) || ""
      );

      formik.setFieldValue(
        "db_url",
        (userPanelData && userPanelData.db_url) || ""
      );
      // formik.setFieldValue('db_name', userPanelData && userPanelData.db_name || '');
      formik.setFieldValue(
        "backend_rul",
        (userPanelData && userPanelData.backend_rul) || ""
      );
      formik.setFieldValue(
        "Create_Strategy",
        userPanelData && userPanelData.Create_Strategy == 1 ? true : false
      );

      formik.setFieldValue(
        "AddClient",
        userPanelData && userPanelData.Addclient == 1 ? true : false
      );
      formik.setFieldValue(
        "InvoicePermission",
        userPanelData && userPanelData.invoice_Permission == 1 ? true : false
      );
      formik.setFieldValue(
        "tradeHistoryDeltaExchange",
        userPanelData && userPanelData.tradeHistoryDeltaExchange == 1 ? true : false
      );
      formik.setFieldValue(
        "sevant_day",
        userPanelData && userPanelData.Two_day_client == 1 ? true : false
      );
    } else {
      formik.setValues({
        panel_name: "",
        domain: "",
        port: "",
        key: "",
        ip_address: "",
        theme_id: "",
        db_url: "",
        // db_name: '',
        broker_id: [],
        Create_Strategy: false,
        Option_chain: false,
        Strategy_plan: false,
        LoginPage: 0,
      });
    }
  }, [UserData.data]);

  const fields = [
    {
      name: "panel_name",
      label: "Panel Name",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "Pandpinfotech",
    },
    {
      name: "domain",
      label: "Domain",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "https://newpenal.deepmindinfotech.com",
    },
    {
      name: "key",
      label: "Key",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "SNE132023",
    },
    {
      name: "ip_address",
      label: "Ip Address",
      type: "placeholder",
      label_size: 12,
      col_size: 6,
      placeholderdata: "193.239.237.136",
    },

    {
      name: "db_url",
      label: "Database Url",
      type: "placeholder",
      label_size: 12,
      col_size: 12,
      placeholderdata:
        "mongodb://pnpinfotech:p%26k56%267GsRy%26vnd%26@193.239.237.136:27017/",
    },
    {
      name: "Create_Strategy",
      label: "Create Strategy",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.Create_Strategy ? true : false,
    },
    {
      name: "AddClient",
      label: "Add Client",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.AddClient ? true : false,
    },
    {
      name: "sevant_day",
      label: "7 Day Client",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.sevant_day ? true : false,
    },
    {
      name: "InvoicePermission",
      label: "Invoice Permission",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.InvoicePermission ? true : false,
    },
    {
      name: "tradeHistoryDeltaExchange",
      label: "Trade History Delta Exchange",
      type: "checkbox",
      label_size: 12,
      col_size: 3,
      check_box_true: formik.values.tradeHistoryDeltaExchange ? true : false,
    },
  ];

  return (
    <>
      {Addsubadmin.loading ? (
        <Loader />
      ) : (
        <>
          <Content
            Page_title="Edit Panel"
            button_title="Back"
            route="/super/alladmins"
          >
            <Formikform
              fieldtype={fields.filter((field) => !field.showWhen)}
              formik={formik}
              btn_name="Update Panel"
            />

            <ToastButton />
          </Content>
        </>
      )}
    </>
  );
};

export default Edit_panel;
